import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface TextareaFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function TextareaField({ field, value, onChange, readOnly, error }: TextareaFieldProps) {
  return (
    <FieldWrapper field={field} error={error}>
      <textarea
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        readOnly={readOnly}
        rows={3}
        className="w-full px-2 py-1.5 text-sm border rounded outline-none focus:ring-1 focus:ring-blue-500 resize-vertical"
        style={{
          backgroundColor: 'var(--color-bg-input, var(--color-bg-card))',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
        }}
      />
    </FieldWrapper>
  )
}
